import { AsyncAction, CommanderThunkAction, WithScope } from '@mews-commander/types';
import { createAction } from '@mews/framework';
import { Identifiable } from '@mews/std';
import { getUrlParameter, createFetchAction } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { fetchActiveEnterpriseServices } from '@mews-commander/legacy-entities/src/actions/services';
import { fetchAccountById } from '@mews-commander/legacy-entities/src/actions/accounts';
import { CUSTOMER_DETAIL_INIT, CUSTOMER_DETAIL_INITIALIZED } from '../actionTypes';
import { CustomerDetailTabs } from '../enums';
import { changeTab } from './tabs';

const isCustomerDetailTab = (value: string): value is CustomerDetailTabs =>
    Object.values<string>(CustomerDetailTabs).includes(value);

export const initCustomerDetail =
    ({ id, scope }: Identifiable & WithScope): CommanderThunkAction<AsyncAction> =>
    async (dispatch) => {
        const urlParamsTab = getUrlParameter('tab') as string;
        const tab = isCustomerDetailTab(urlParamsTab) ? urlParamsTab : CustomerDetailTabs.Profile;

        const fetchActions = [
            dispatch(
                fetchAccountById({
                    accountId: id,
                    extent: {
                        addresses: true,
                        relatedCustomers: true,
                        files: true,
                        creditLimits: true,
                        legalIdentifiers: true,
                        profiles: true,
                        identityDocuments: true,
                    },
                })
            ).then(() => dispatch(changeTab(tab, scope, id))),
            dispatch(fetchActiveEnterpriseServices({ enterpriseIds: [getCurrentEnterpriseId()] })),
        ];
        const initChain = Promise.all(fetchActions).then(() =>
            dispatch(createAction(CUSTOMER_DETAIL_INITIALIZED, undefined, { scope }))
        );

        return dispatch(createFetchAction(CUSTOMER_DETAIL_INIT, initChain, { scope }));
    };
